// Translations
import phoneVerificationDialog from '../components/phone-verification-dialog/translations/ar'

// Translation: Model > Phone number verifier (Arabic)
export default Object.freeze({
	actions: {
		verify: ''
	},
	components: { phoneVerificationDialog }
})
